import { render, staticRenderFns } from "./createTopup.vue?vue&type=template&id=70eb563a&scoped=true&"
import script from "./createTopup.vue?vue&type=script&lang=js&"
export * from "./createTopup.vue?vue&type=script&lang=js&"
import style0 from "./createTopup.vue?vue&type=style&index=0&id=70eb563a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eb563a",
  null
  
)

export default component.exports